// TODO: pjax?

(function ($) {
  $(document).ready(function () {
    $("form").on("submit", function (event) {
      if($(event.target).attr('novalidate')){
        //Ein UGC-Formular hat seine eigene "Button"-Disable-Funktion
        console.log("UGC-Formular");
        return;
      }
      $(event.target)
        .find("[type=submit][data-disable-on-submit=true]")
        .each(function (index, element) {
          if (this.hasAttribute("data-text-after-submit")) {
            if (this.tagName === "BUTTON") {
              $(this).data("resetText", this.textContent);
              this.textContent = this.getAttribute("data-text-after-submit");
            } else {
              $(this).data("resetText", this.value);
              this.value = this.getAttribute("data-text-after-submit");
            }
          }
          this.disabled = true;
        });
    });
  });
})(window.jQuery);
